<template>
    <div class="menu">
        <router-link
            v-for="(item,index) in menuData"
            :key="index"
            :to="item.link"
            class="menu_item"
        >
            <el-badge v-if="item.icon == 'shopping_car' && shoppingCarCount >0" :value="shoppingCarCount" class="item">
                <p :class="`menu_icon menu_${item.icon}`"></p>
            </el-badge>
            <el-badge v-else-if="item.icon == 'sys' && chatroomNotReadTotal>0" :value="chatroomNotReadTotal" :max="10" class="item">
                <p :class="`menu_icon menu_${item.icon}`"></p>
            </el-badge>
            <p :class="`menu_icon menu_${item.icon}`" v-else></p>
            <p class="menu_name ">{{item.name}}</p>
        </router-link>
    </div>
</template>

<script>
    import FN from '@/components/fn';
    import {mapActions} from 'vuex';

    export default {
        mixins: [FN],
        name: 'menu',
        data() {
            return {
                menuData: [
                    {
                        name: '首頁',
                        icon: 'home',
                        link: '/home'
                    },
                    {
                        name: '商城',
                        icon: 'store',
                        link: '/store'
                    },
                    {
                        name: '聯絡賣家',
                        icon: 'sys',
                        link: '/store/chatroom'
                    },
                    {
                        name: '購物車',
                        icon: 'shopping_car',
                        link: '/store/car'
                    },
                    {
                        name: '我的訂單',
                        icon: 'store_center',
                        link: '/store/customer/center'
                    },
                ],
                shoppingCarCount:0,
                chatroomNotReadTotal: 0
            }
        },
        mounted() {
            this.getShoppingCarCount();
            this.getChatroomNotReadTotal();
        },
        methods: {
            ...mapActions([
                'FETCH'
            ]),
            getShoppingCarCount() {
                this.FETCH({
                    key: 'GET_SHOPPING_CAR_COUNT',
                }).then((res) => {
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.getShoppingCarCount);
                    }
                    this.shoppingCarCount=res.data.count;
                })
            },
            getChatroomNotReadTotal(){
                this.FETCH({
                    key: 'GET_CHATROOM_NOT_READ_TOTAL',
                }).then((res) => {
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.getChatroomNotReadTotal);
                    }
                    this.chatroomNotReadTotal=res.data.count;
                })
            }
        },
    }
</script>
